// extracted by mini-css-extract-plugin
export default {"menu":"ContextMenuContainer_menu__ETErS"};